import { Button } from '@/components'
import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const SectionTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
`

export const FieldLabel = styled.label`
  font-size: 13px;
  color: #666;
`

export const RequiredMark = styled.span`
  color: #d85a30;
`

export const FieldHint = styled.span`
  font-size: 12px;
  color: #888;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`

export const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const PlatformSelect = styled.select`
  height: ${Tokens.HeightInput};
  border-radius: ${Tokens.RadiusInput};
  padding: 0 16px;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: ${Tokens.ColorTextPrimary};
  background-color: ${Tokens.ColorBackground};
  cursor: pointer;
  flex-shrink: 0;
  width: 130px;

  &:hover,
  &:focus {
    background-color: ${Tokens.ColorHover};
  }

  option {
    background-color: ${Tokens.ColorBackground};
    color: ${Tokens.ColorTextPrimary};
    padding: 0.5rem;
    border-radius: 0.5rem;

    &:hover {
      background-color: ${Tokens.ColorUIPrimary};
      color: ${Tokens.ColorWhite};
    }
  }
`

export const AddNetworkBtn = styled(Button.Root)`
  align-self: flex-start;
`
